import { Drupal } from '@typings/drupal';
import { DISTRICT_TABS } from '@domain/districts';

export default (tabs: Drupal.MenuItem[], filter: DISTRICT_TABS[]) =>
  filter.length > 0
    ? tabs.filter(tab => !filter.includes(tab.id as DISTRICT_TABS))
    : tabs;
